import { useCallback } from "react";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import useElevatedRiskMonitoringBanner from "./useElevatedRiskMonitoringBanner";

/**
 * Navigate to /properties and open the same upgrade modal flow as MapSection.
 */
export function usePropertyUpgradeNavigation() {
  const navigate = useNavigate();
  const { firstAtRiskPropertyId } = useElevatedRiskMonitoringBanner();
  const { propertiesData } = useSelector(
    (state: { properties?: { propertiesData?: Array<{ id?: number | string }> } }) =>
      state?.properties ?? {},
  );

  const goToPropertyUpgrade = useCallback(
    (propertyId?: number | string | null) => {
      const resolvedId =
        propertyId ??
        firstAtRiskPropertyId ??
        propertiesData?.[0]?.id ??
        null;

      navigate("/properties", {
        state: resolvedId
          ? { openUpgradePropertyId: resolvedId }
          : { openUpgradeFlow: true },
      });
    },
    [firstAtRiskPropertyId, navigate, propertiesData],
  );

  return { goToPropertyUpgrade, firstAtRiskPropertyId };
}

export default usePropertyUpgradeNavigation;
